import React, { useState } from 'react';
import {
  Card, Col, Row, Dropdown, Menu, Typography
} from 'antd';
import {
  MoreOutlined
} from '@ant-design/icons';

const IconImg = (props) => (
  <img src={props.name} alt={props.name} />
);

const { Link } = Typography;

export default function CardComponent(props) {
  const [showCardCompValue, setCardCompValue] = useState('TOTAL');

  const cardTitle = (
    <Row className="card-title">
      <Col span={6} className="icon-bg">
        <div><IconImg name={props.OrdersIcon} /></div>
      </Col>
      <Col span={18} className="title-content">
        {showCardCompValue === 'TOTAL' && (
          <>
            <p>Total Orders</p>
            <span>{props.data.total_orders && props.data.total_orders.total}</span>
          </>
        )}
        {showCardCompValue === 'PURCHASE' && (
          <>
            <p>Purchase Orders</p>
            <span>{props.data.total_orders && props.data.total_orders_purchase.total}</span>
          </>
        )}
        {showCardCompValue === 'RENTAL' && (
          <>
            <p>Rental Orders</p>
            <span>{props.data.total_orders && props.data.total_orders_rental.total}</span>
          </>
        )}
      </Col>
    </Row>
  );

  const dropDown = (
    <Dropdown
      placement="bottomRight"
      overlay={(
        <Menu>
          <Menu.Item key="0" onClick={() => setCardCompValue('TOTAL')}>
            <span>
              Total
            </span>
          </Menu.Item>
          <Menu.Item key="1" onClick={() => setCardCompValue('PURCHASE')}>
            <span>
              Purchase
            </span>
          </Menu.Item>
          <Menu.Item
            key="2"
            onClick={() => setCardCompValue('RENTAL')}
          >
            Rental
          </Menu.Item>
        </Menu>
      )}
      trigger={['click']}
    >
      <Link className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
        <MoreOutlined className="moreOutlined" />
      </Link>
    </Dropdown>
  );

  return (
    props.data ? (
      <Card
        bordered={false}
        title={cardTitle}
        className='dashboard-card'
        extra={dropDown}>
        {showCardCompValue === 'TOTAL' && (
          <>
            <p className='card-component-content'>Monthly: <span>{props.data.total_orders.monthly}</span></p>
            <p className='card-component-content'>Weekly: <span>{props.data.total_orders.weekly}</span></p>
            <p className='card-component-content'>Today: <span>{props.data.total_orders.today}</span></p>
          </>
        )}
        {showCardCompValue === 'PURCHASE' && (
          <>
            <p className='card-component-content'>Monthly: <span>{props.data.total_orders_purchase.monthly}</span></p>
            <p className='card-component-content'>Weekly: <span>{props.data.total_orders_purchase.weekly}</span></p>
            <p className='card-component-content'>Today: <span>{props.data.total_orders_purchase.today}</span></p>
          </>
        )}
        {showCardCompValue === 'RENTAL' && (
          <>
            <p className='card-component-content'>Monthly: <span>{props.data.total_orders_rental.monthly}</span></p>
            <p className='card-component-content'>Weekly: <span>{props.data.total_orders_rental.weekly}</span></p>
            <p className='card-component-content'>Today: <span>{props.data.total_orders_rental.today}</span></p>
          </>
        )}
      </Card>
    ) : null
  );
}
